export default async function fetchData(eventId){
    const URL = `https://abstrakty.ptkardio.pl/files/plan/${eventId}.json`;

    let response = await fetch(URL);

    if(!response.ok) return;
    
    let data = response.json();

    return data;

}